import styled from "styled-components";

interface HeadingStyledProps {
  isNameAvailable?: boolean;
}

interface StationSelectionWrapperStyledProps {
  hasSelection: boolean;
  isDisabled: boolean;
}

interface CurrentItemStyledProps {
  hasSelection: boolean;
}

interface HelpDropdownBtnProps {
  active: boolean;
}

interface DropdownContentStyledProps {
  isSemanticMap?: boolean;
}

export const HeadingStyled = styled.div<HeadingStyledProps>`
  font-size: 48px;
  color: ${(props) => (props.isNameAvailable ? "#0f625f" : "#d1d1d1")};
`;

export const StationSelectionWrapperStyled = styled.div<StationSelectionWrapperStyledProps>`
  position: relative;
  padding: 24px 12px 24px 0;
  background: #f4f4f4;
  background: ${(props) => (props.hasSelection ? "#fff" : "#3f7f7d")};
  cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};
`;

export const StationSelectorDropdownStyled = styled.div<HelpDropdownBtnProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  svg {
    transform: ${(props) =>
      props.active ? "rotateX(180deg)" : "rotateX(0deg)"};
    transition: 0.3s;
  }
`;

export const CurrentItemStyled = styled.div<CurrentItemStyledProps>`
  font-family: "Readex Pro", sans-serif;
  font-size: ${(props) => (props.hasSelection ? "36px" : "20px")};
  color: ${(props) => (props.hasSelection ? "#3f7f7d" : "#fff")};
  padding: ${(props) => (props.hasSelection ? "0" : "0 20px")};
  white-space: nowrap;
  overflow: ${(props) => (props.hasSelection ? "hidden" : "visible")};
  text-overflow: ellipsis;
`;

export const DropdownContentStyled = styled.div<DropdownContentStyledProps>`
  background-color: #ffffff;
  position: absolute;
  width: 100%;
  top: ${(props) => (props.isSemanticMap ? "50px" : "75px")};
  padding: 8px 0;
  box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
  z-index: 1;
  max-height: 400px;
  overflow-y: auto;
`;

export const DropdownItemStyled = styled.div`
  font-size: 16px;
  color: #606060;
  padding: 14px 18px;
  border-bottom: 1px solid transparent;
  transition: all 0.3s;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &:hover {
    color: #55b8b3;
    border-bottom: 1px solid #55b8b3;
  }
`;

export const PlaceholderStyled = styled.div`
  font-size: 20px;
  text-decoration: underline;
  color: #d1d1d1;
`;
